import script from "./ArgonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonModal.vue?vue&type=script&setup=true&lang=js"

import "./ArgonModal.vue?vue&type=style&index=0&id=c095c0ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c095c0ce"]])

export default __exports__